import React from "react";
import { Link } from "react-router-dom";
import { StyleTag } from "seed/helpers";
import { useGet } from "seed/api";

const CustomViewWrapper = ({
  flowId,
  customView
}) => {

  const reqCustomView = useGet(`/executions/get_query_result`, {
    flow_id: flowId,
    query: customView.url
  });

  if(reqCustomView.loading) return;
  const customViewURL = reqCustomView.data;

  return <div className="w-100 h-100 d-flex justify-content-center align-items-center position-relative">
    <iframe
      className="w-100 h-100 border-0"
      src={customViewURL}
      title={customView.name}
    ></iframe>
    <StyleTag content={`
      #presentation-nav-section.${customView.name}{
        width: ${customView.width ?? 32}rem !important;
        min-width: ${customView.width ?? 32}rem !important;
        max-width: ${customView.width ?? 32}rem !important;
      }
    `} />
    <Link
      to={`/views/${customView.name}`}
      className="btn btn-sm btn-outline-primary-white position-absolute z-3 bottom-0 right-0 m-2"
    >
      <i className="fas fa-expand-arrows-alt"></i>
    </Link>
  </div>;

}

export default CustomViewWrapper;